import { createAsyncThunk } from "@reduxjs/toolkit";
import periodEventDataService from "../../../api/services/periodEventData";
import classesService from "../../../api/services/classes";

export const fetchPeriodEventData = createAsyncThunk(
  "periodEventData/fetchPeriodEventData",
  async () => await periodEventDataService.fetchPeriodEventData()
);

export const fetchBestWorstStudents = createAsyncThunk(
  "periodEventData/fetchBestWorstStudents",
  async () => await classesService.fetchDashboardData()
);
